<div class="modal inmodal fade in parcel-modal create-modal show">
    <form #form="ngForm" (ngSubmit)="onSubmit(form)" submittable autocomplete="off">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <button type="button" class="close" (click)="hideModal()">
                        <span>×</span><span class="sr-only">Close</span>
                    </button>
                    <h4 class="modal-title col-sm-8">
                        Parcel {{settingsParcelsService.notificationModalNotificationType != 'pickedUp' ? settingsParcelsService.notificationModalNotificationType : 'Picked Up'}} SMS
                    </h4>
                </div>
                <div class="modal-body">
                    <div class="form-group" id="summernote">{{message}}</div>
                    <div class="num-of-characters">{{message.length}}/500</div>

                    <div class="row text-center">
                        <button type="submit" class="btn btn-primary submit-btn" [disabled]="disabledSubmit">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </form>
    <div class="modal-backdrop fade in" (click)="hideModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/settings-parcels/sms-notification-modal/sms-notification-modal.component.html